import { callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import {
    Edit_RestaurantEmployee_List_Item_PUT,
    Get_RestaurantEmployee_List_Item_GET,
    Save_RestaurantEmployee_List_Item_POST,
} from "api/ApiConst";
import { API_SUCCESS } from "api/ResponseCodes";
import ImageSelector from "components/common/ImageSelector";
import ModalWrapper from "components/common/ModalWrapper";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";
import { MODAL_LOADER } from "utils/constants";
import { isEmpty } from "utils/TextUtils";

const RestaurantEmployeeAddEdit = ({
    show,
    hideModal,
    recordID,
    handleRefresh,
    cuisineKeyPairList,
    resturentKeyPairList,
}) => {
    const defaultRecordObj = {
        firstName: "",
        lastName: "",
        isdCode: "+91",
        mobile: "",
        email: "",
        username: "",
        password: "",
        photoImageRefId: "",
        restaurantUuid: "",
        cuisineUuids: [],
    };

    const [record, setRecord] = useState(defaultRecordObj);

    const checkInputValidation = () => {
        // if (isEmpty(record.photoImageRefId)) {
        //     toast.error("Image must not be empty.", {
        //         id: "photoImageRefId",
        //     });
        //     return;
        // } else 
        if (isEmpty(record.firstName)) {
            toast.error("First Name must not be empty.", {
                id: "firstName",
            });
            return;
        } else if (isEmpty(record.lastName)) {
            toast.error("Last Name must not be empty.", {
                id: "lastName",
            });
            return;
        } else if (isEmpty(record.isdCode)) {
            toast.error("ISD Code must not be empty.", {
                id: "isdCode",
            });
            return;
        } else if (isEmpty(record.mobile)) {
            toast.error("Mobile Number must not be empty.", {
                id: "mobile",
            });
            return;
        } 
        // else if (isEmpty(record.email)) {
        //     toast.error("Email must not be empty.", {
        //         id: "email",
        //     });
        //     return;
        // } 
        else if (isEmpty(record.restaurantUuid)) {
            toast.error("Restaurent must not be empty.", {
                id: "email",
            });
            return;
        } else if (isEmpty(record.cuisineUuids)) {
            toast.error("Categories must not be empty.", {
                id: "email",
            });
            return;
        } 
        // else if (isEmpty(record.username)) {
        //     toast.error("Username must not be empty.", {
        //         id: "username",
        //     });
        //     return;
        // } else if (!recordID) {
        //     if (isEmpty(record.password)) {
        //         toast.error("Password must not be empty.", {
        //             id: "password",
        //         });
        //         return;
        //     }
        // }
        return true;
    };

    const handleSubmit = () => {
        try {
            if (!checkInputValidation()) {
                return;
            }

            const _cuisineUuids = [];
            record.cuisineUuids.map((data) => _cuisineUuids.push(data.key));

            const recordObj = {
                ...record,
                cuisineUuids: _cuisineUuids,
                restaurantUuid: record.restaurantUuid?.key || "",
            };

            if (recordID) {
                // update
                callPutApi(
                    MODAL_LOADER,
                    Edit_RestaurantEmployee_List_Item_PUT.replace(
                        "{uuid}",
                        recordID
                    ),
                    recordObj,
                    {},
                    (res) => {
                        if (res.errorCode === API_SUCCESS) {
                            hideModal(false);
                            handleRefresh();
                        }
                    }
                );
            } else {
                // Create
                callPostApi(
                    MODAL_LOADER,
                    Save_RestaurantEmployee_List_Item_POST,
                    recordObj,
                    {},
                    (res) => {
                        if (res.errorCode === API_SUCCESS) {
                            hideModal(false);
                            handleRefresh();
                        }
                    },
                    (error) => {
                        console.log(error);
                    }
                );
            }
        } catch (error) {
            return;
        }
    };

    useEffect(() => {
        recordID &&
            callGetApi(
                MODAL_LOADER,
                Get_RestaurantEmployee_List_Item_GET.replace(
                    "{uuid}",
                    recordID
                ),
                {},
                (response) => {
                    if (response.errorCode === API_SUCCESS) {
                        const res = response.responsePacket;

                        const _restaurentUuid = resturentKeyPairList.find(
                            (obj) => obj.key === res.restaurantUuid
                        );

                        const _cuisineUuids = [];

                        cuisineKeyPairList.map((obj) =>
                            res.cuisineUuids.map((resObj) => {
                                if (obj.key === resObj) {
                                    _cuisineUuids.push(obj);
                                }
                            })
                        );

                        setRecord({
                            firstName: res.firstName,
                            lastName: res.lastName,
                            isdCode: res.isdCode,
                            mobile: res.mobile,
                            email: res.email,
                            username: res.username,
                            password: res.password,
                            photoImageRefId: res.photoImageRefId,
                            restaurantUuid: _restaurentUuid || "",
                            cuisineUuids: _cuisineUuids || "",
                        });
                    }
                }
            );
    }, [recordID]);
    const handleGameIconChange = (imageRefId) => {
        setRecord({ ...record, photoImageRefId: imageRefId });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "mobile") {
            if (value.length > 10) {
                return;
            }
        }
        setRecord({ ...record, [name]: value });
    };
    const handleSelectCuisineChange = (e) => {
        setRecord((pre) => ({ ...pre, cuisineUuids: e }));
    };
    const handleSelectRestaurentChange = (e) => {
        setRecord((pre) => ({ ...pre, restaurantUuid: e }));
    };
    return (
        <>
            <ModalWrapper
                show={show}
                hide={hideModal}
                header={`${recordID ? "Update" : "Add"}`}
                handleSubmit={handleSubmit}
            >
                <div className="container">
                    <div className="row">
                        <div className="mb-3 col-12">
                            <ImageSelector
                                style={{
                                    height: "120px",
                                    width: "120px",
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    margin: "0 auto",
                                }}
                                user={true}
                                handleImageChange={handleGameIconChange}
                                selectedImage={record.photoImageRefId}
                            />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label htmlFor="firstName" className="form-label">
                                First Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={record.firstName}
                                name="firstName"
                                onChange={(e) => handleInputChange(e)}
                            ></input>
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label htmlFor="lastName" className="form-label">
                                Last Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={record.lastName}
                                name="lastName"
                                onChange={(e) => handleInputChange(e)}
                            ></input>
                        </div>
                        {/* <div className="col-lg-6 mb-3">
              <label htmlFor="dob" className="form-label">
                Date Of Birth
              </label>
              <input
                type="date"
                className="form-control"
                value={record?.dateOfBirthTimeStamp}
                name="dateOfBirthTimeStamp"
                onChange={(e) => handleInputChange(e)}
              ></input>
            </div> */}
                        {/* <div className="col-lg-6 mb-3">
              <label htmlFor="gender" className="form-label">
                Gender
              </label>
              <span className="d-flex justify-content-between align-items-center">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="gender"
                    id="male"
                    value="Male"
                    onChange={(e) => handleInputChange(e)}
                    checked={"Male" === record.gender}
                  />
                  <label className="form-check-label" htmlFor="male">
                    Male
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="gender"
                    id="female"
                    value="Female"
                    onChange={(e) => handleInputChange(e)}
                    checked={"Female" === record.gender}
                  />
                  <label className="form-check-label" htmlFor="female">
                    Female
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="gender"
                    id="other"
                    value="Other"
                    onChange={(e) => handleInputChange(e)}
                    checked={"Other" === record.gender}
                  />
                  <label className="form-check-label" htmlFor="other">
                    Other
                  </label>
                </div>
              </span>
            </div> */}
                        <div className="col-lg-6 mb-3">
                            <div className="row">
                                <div className="col-4">
                                    <label
                                        htmlFor="isdCode"
                                        className="form-label"
                                    >
                                        ISD Code
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={record.isdCode}
                                        name="isdCode"
                                        onChange={(e) => handleInputChange(e)}
                                    ></input>
                                </div>
                                <div className="col-8">
                                    <label htmlFor="" className="form-label">
                                        Mobile
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={record.mobile}
                                        name="mobile"
                                        onChange={(e) => handleInputChange(e)}
                                    ></input>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-3">
                            {/* <label htmlFor="firstName" className="form-label">
                                Email
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                value={record.email}
                                name="email"
                                onChange={(e) => handleInputChange(e)}
                            ></input> */}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label htmlFor="firstName" className="form-label">
                                Restaurant
                            </label>
                            <Select
                                value={record?.restaurantUuid}
                                onChange={handleSelectRestaurentChange}
                                options={resturentKeyPairList}
                            />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label htmlFor="firstName" className="form-label">
                                Categories
                            </label>
                            <MultiSelect
                                value={record?.cuisineUuids}
                                onChange={handleSelectCuisineChange}
                                options={cuisineKeyPairList}
                            />
                        </div>
                        {/* <div className="col-lg-6 mb-3">
                            <label htmlFor="firstName" className="form-label">
                                Username
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={record.username}
                                name="username"
                                onChange={(e) => handleInputChange(e)}
                            ></input>
                        </div>
                        {!recordID && (
                            <div className="col-lg-6 mb-3">
                                <label
                                    htmlFor="firstName"
                                    className="form-label"
                                >
                                    Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={record.password}
                                    name="password"
                                    onChange={(e) => handleInputChange(e)}
                                ></input>
                            </div>
                        )} */}
                    </div>
                </div>
            </ModalWrapper>
        </>
    );
};

export default RestaurantEmployeeAddEdit;
